import { Header, Indicator, Item, ScrollContainer, TimeTable } from './styles'

TimeTable.Header = Header
TimeTable.Item = Item
TimeTable.Indicator = Indicator
TimeTable.ScrollContainer = ScrollContainer

export default TimeTable
